import { MessagingHelper } from '../helpers/MessagingHelper';
import { PaginatedList } from '../helpers/PaginatedList';
import { CounterTypeCreateDTO } from '../models/Counter/CounterTypeCreateDTO';
import { CounterTypeDTO } from "../models/Counter/CounterTypeDTO";
import { Parameter } from '../models/Parameter';
import { APIService } from "./APIService";

export class CounterTypeService {
  async GetAll(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number,
  ): Promise<PaginatedList<CounterTypeDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/CounterType/GetAll`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        },
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<CounterTypeDTO>(
        false,
        "Erro ao ligar ao servidor para obter tipos de contadores",
        "",
        [],
        0,
      );
    }
  }

  async CreateCounter(createClientStatus: CounterTypeCreateDTO): Promise<MessagingHelper<number>> {
    try {
      var response = await APIService.Axios().post(`${APIService.GetURL()}/CounterType/Create`,
        {
          ...createClientStatus
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + APIService.GetToken()
          }
        });
      return response.data;
    } catch (error) {
      return new MessagingHelper<number>(false, "Erro ao ligar ao servidor para criar o contador", 0);
    };
  }
}
